import ky, { type Options } from 'ky';

interface SendRequestOptions extends Options {
    endpointName: string;
    url: string;
    apiChannelExtraOptions?: any;
}

export function sendTbApiRequest<T>({
    url,
    endpointName,
    apiChannelExtraOptions = {},
    ...options
}: SendRequestOptions): Promise<T> {
    if (window.tbApiChannelClient) {
        return window.tbApiChannelClient.sendRequest<T>(
            endpointName,
            {
                ...apiChannelExtraOptions,
                json: options.json
            },
            options.signal,
            typeof options.timeout === 'number' ? options.timeout : undefined
        );
    }

    return ky(url, options).json<T>();
}
